export default {
    NodeWS: null,
    NodeXHR: null,
    getGlobalCookiesForNode: function() {},
    addGlobalCookiesForNode: function() {}
};